import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { Select, Button, Table, Tag, Card, Row, Col, Typography, DatePicker } from 'antd';
import PrintButton from '../../../components/admin/PrintButton';

const { Option } = Select;
const { Title } = Typography;
const { RangePicker } = DatePicker;

const MessagesReport = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: 'ALL',
    dates: null,
  });
  const { token } = useAuth();

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const params = {
        page: 1,
        limit: 100,
      };
      if (filters.status && filters.status !== 'ALL') {
        params.status = filters.status;
      }
      if (filters.dates && filters.dates.length === 2) {
        params.startDate = filters.dates[0].toISOString();
        params.endDate = filters.dates[1].toISOString();
      }
      const response = await api.get('/api/messages', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setMessages(response.data.messages);
    } catch (error) {
      console.error('Failed to fetch messages', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    fetchMessages();
  };

  useEffect(() => {
    fetchMessages();
  }, [token]);

  const columns = [
    { title: 'الاسم', dataIndex: 'name', key: 'name' },
    { title: 'البريد الإلكتروني', dataIndex: 'email', key: 'email' },
    { title: 'الموضوع', dataIndex: 'subject', key: 'subject' },
    {
      title: 'الحالة',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'geekblue';
        let text = 'غير مقروء';
        if (status === 'READ') {
          color = 'green';
          text = 'مقروء';
        }
        if (status === 'REPLIED') {
          color = 'volcano';
          text = 'تم الرد';
        }
        if (status === 'ARCHIVED') {
          color = 'gold';
          text = 'مؤرشف';
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: 'تاريخ الاستلام',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => new Date(date).toLocaleDateString('ar-SA'),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={3}>تقرير رسائل الاتصال</Title>
        <PrintButton />
      </div>
      <Card title="تقرير رسائل الاتصال">
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }} className="no-print">
            <Col>
              <Select
                placeholder="اختر الحالة"
                style={{ width: 150 }}
                onChange={(value) => handleFilterChange('status', value)}
                defaultValue="ALL"
              >
                <Option value="ALL">الكل</Option>
                <Option value="UNREAD">غير مقروء</Option>
                <Option value="READ">مقروء</Option>
                <Option value="REPLIED">تم الرد</Option>
                <Option value="ARCHIVED">مؤرشف</Option>
              </Select>
            </Col>
            <Col>
              <RangePicker
                onChange={(dates) => handleFilterChange('dates', dates)}
                placeholder={['تاريخ البدء', 'تاريخ الانتهاء']}
              />
            </Col>
            <Col>
              <Button type="primary" onClick={handleSearch}>
                بحث
              </Button>
            </Col>
          </Row>
          <Table
            dataSource={messages}
            columns={columns}
            rowKey="id"
            loading={loading}
            scroll={{ x: true }}
          />
        </div>
      </Card>
    </div>
  );
};

export default MessagesReport;